import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/login/login-img.png'


const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "image-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "login-image",
  width: "100%",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "augmentify-welcome-message" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Welcome to ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "augmentify-text" }, "Augmentify", -1)

import { ref } from "vue";
import { NLayout, NLayoutContent, NLayoutHeader, NGrid, NGi, NSwitch } from 'naive-ui'
import { augmentifyLogo } from "@/assets/utils/icons";
import LoginForm from "@/components/LoginForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const active = ref(true)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NLayout), null, {
    default: _withCtx(() => [
      _createVNode(_unref(NLayoutHeader), { class: "header grid-container text-align-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", { innerHTML: _unref(augmentifyLogo) }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      _createVNode(_unref(NLayoutContent), { "content-class": "login-layout grid-container" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NGrid), {
            "x-gap": "12",
            cols: 12,
            "item-responsive": "",
            responsive: "screen"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NGi), {
                span: "12 s:6 m:6 l:7",
                class: "height-100 flex-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("span", _hoisted_4, [
                      _hoisted_5,
                      _hoisted_6,
                      _createVNode(_unref(NSwitch), {
                        value: active.value,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
                        size: "medium"
                      }, null, 8, ["value"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(NGi), {
                span: "12 s:6 m:5 l:4",
                offset: "m:1"
              }, {
                default: _withCtx(() => [
                  _createVNode(LoginForm)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})